import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, FileText } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { contactInfo } from '../mock';

const telHref = `tel:+386${contactInfo.phone.replace(/\s/g, '').replace(/^0/, '')}`;

export const MobileContactBar = () => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  if (pathname === '/contact') return null;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-black/90 backdrop-blur-xl border-t border-white/10 px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-[0_-10px_25px_rgba(0,0,0,0.7)]"
      data-testid="mobile-contact-bar"
    >
      <div className="grid grid-cols-2 gap-3">
        <a
          href={telHref}
          className="flex items-center justify-center gap-2 min-h-[48px] rounded-xl font-bold text-xs uppercase tracking-wider bg-white/5 border border-white/15 text-white active:bg-white/10"
          style={{ fontFamily: "'Exo 2', sans-serif" }}
          data-testid="mobile-call-button"
        >
          <Phone className="w-4 h-4" />
          {t({ sl: 'Pokliči', en: 'Call', it: 'Chiama' })}
        </a>
        <Link
          to="/contact"
          className="flex items-center justify-center gap-2 min-h-[48px] rounded-xl font-bold text-xs uppercase tracking-wider text-black bg-gradient-to-r from-cyan-400 via-fuchsia-500 to-yellow-400 active:opacity-90 shadow-lg shadow-cyan-500/20"
          style={{ fontFamily: "'Exo 2', sans-serif" }}
          data-testid="mobile-quote-button"
        >
          <FileText className="w-4 h-4" />
          {t({ sl: 'Ponudba', en: 'Get a quote', it: 'Preventivo' })}
        </Link>
      </div>
    </div>
  );
};
